import React, { useState, useEffect } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { TextTemplate } from '../../api/socialCards';

interface TextDropdownProps {
  templates: TextTemplate[];
  eventName: string;
  onTextSelect: (template: string, customText?: string) => void;
}

const TextDropdown: React.FC<TextDropdownProps> = ({ templates, eventName, onTextSelect }) => {
  const [selectedTemplate, setSelectedTemplate] = useState<string>('attending');
  const [customText, setCustomText] = useState<string>('');
  const [previewText, setPreviewText] = useState<string>('');

  useEffect(() => {
    updatePreviewText(selectedTemplate, customText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate, customText, eventName]);

  const updatePreviewText = (template: string, custom: string) => {
    if (template === 'custom') {
      setPreviewText(custom || "I'm attending");
    } else {
      const templateText = templates.find(t => t.value === template)?.label || "I'm attending";
      setPreviewText(templateText);
    }
  };

  const handleTemplateChange = (value: string) => {
    setSelectedTemplate(value);
    onTextSelect(value, value === 'custom' ? customText : undefined);
  };

  const handleCustomTextChange = (value: string) => {
    setCustomText(value);
    if (selectedTemplate === 'custom') {
      onTextSelect('custom', value);
    }
  };


  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Announcement Text
        </label>
        <div className="relative">
          <select
            value={selectedTemplate}
            onChange={(e) => handleTemplateChange(e.target.value)}
            className="w-full appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
          >
            {templates.map((template) => (
              <option key={template.value} value={template.value}>
                {template.label}
              </option>
            ))}
          </select>
          <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
        </div>
      </div>

      {selectedTemplate === 'custom' && (
        <div className="animate-fadeIn">
          <input
            type="text"
            value={customText}
            onChange={(e) => handleCustomTextChange(e.target.value)}
            placeholder="Enter your custom announcement..."
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            maxLength={50}
          />
          <p className="text-xs text-gray-500 mt-1">
            {customText.length}/50 characters
          </p>
        </div>
      )}

      <div className="bg-gray-50 px-3 py-2 rounded-lg">
        <p className="text-xs text-gray-600 uppercase tracking-wide mb-1">Preview</p>
        <p className="text-sm font-medium text-gray-900">
          {previewText} <span className="text-indigo-600">{eventName}</span>
        </p>
      </div>
    </div>
  );
};

export default TextDropdown;